import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRotate90Right12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconRotate90Right12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Rotate90Right12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M9.5 1H8V0h1.5A2.5 2.5 0 0 1 12 2.5V4h-1V2.5A1.5 1.5 0 0 0 9.5 1M5 2.5v-.024 2.042zM9.52 7H7.48zM2 10h-.5A1.5 1.5 0 0 1 0 8.5v-7A1.5 1.5 0 0 1 1.5 0h4A1.5 1.5 0 0 1 7 1.5V5h3.5A1.5 1.5 0 0 1 12 6.5v4a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 2 10.5zm4-8.5V5H3.5A1.5 1.5 0 0 0 2 6.5V9h-.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5M3.5 6h7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Rotate90Right12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconRotate90Right12);
